var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0879,
    cy: 22.6913,
    r: 1.085,
    transform: "rotate(-89.8485 12.0879 22.6913)",
    fill: "url(#paint0_linear_5554_11741)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0957,
    cy: 19.3905,
    r: 1.085,
    transform: "rotate(-89.8485 12.0957 19.3905)",
    fill: "url(#paint1_linear_5554_11741)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1054,
    cy: 16.0858,
    r: 1.085,
    transform: "rotate(-89.8485 12.1054 16.0858)",
    fill: "url(#paint2_linear_5554_11741)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9785,
    cy: 22.6913,
    r: 1.085,
    transform: "rotate(-89.8485 15.9785 22.6913)",
    fill: "url(#paint3_linear_5554_11741)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9863,
    cy: 19.3905,
    r: 1.085,
    transform: "rotate(-89.8485 15.9863 19.3905)",
    fill: "url(#paint4_linear_5554_11741)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9961,
    cy: 16.0858,
    r: 1.085,
    transform: "rotate(-89.8485 15.9961 16.0858)",
    fill: "url(#paint5_linear_5554_11741)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2L14.48 1.29977L14 0.970799L13.52 1.29977L14 2ZM27 10.9105L26.6006 11.6596L27.48 10.2102L27 10.9105ZM1 10.9105L0.520047 10.2102L1.39936 11.6596L1 10.9105ZM14 3.9801L14.3994 3.23097L14 3.01807L13.6006 3.23097L14 3.9801ZM5.6156 11.125V10.2761H4.76667V11.125H5.6156ZM22.4419 11.125H23.2908V10.2761H22.4419V11.125ZM21.8632 11.125V10.2761H21.0142V11.125H21.8632ZM6.19432 11.125H7.04325V10.2761H6.19432V11.125ZM13.52 2.70023L26.52 11.6107L27.48 10.2102L14.48 1.29977L13.52 2.70023ZM1.47995 11.6107L14.48 2.70023L13.52 1.29977L0.520047 10.2102L1.47995 11.6107ZM13.6006 3.23097L0.600638 10.1613L1.39936 11.6596L14.3994 4.72923L13.6006 3.23097ZM27.3994 10.1613L14.3994 3.23097L13.6006 4.72923L26.6006 11.6596L27.3994 10.1613ZM6.46453 25.0118V11.125H4.76667V25.0118H6.46453ZM7.60282 26.1501C6.97416 26.1501 6.46453 25.6405 6.46453 25.0118H4.76667C4.76667 26.5782 6.03646 27.848 7.60282 27.848V26.1501ZM20.4547 26.1501H7.60282V27.848H20.4547V26.1501ZM21.5929 25.0118C21.5929 25.6405 21.0833 26.1501 20.4547 26.1501V27.848C22.021 27.848 23.2908 26.5782 23.2908 25.0118H21.5929ZM21.5929 11.125V25.0118H23.2908V11.125H21.5929ZM21.8632 11.9739H22.4419V10.2761H21.8632V11.9739ZM22.7121 25.0118V11.125H21.0142V25.0118H22.7121ZM20.4547 27.2693C21.7014 27.2693 22.7121 26.2586 22.7121 25.0118H21.0142C21.0142 25.3209 20.7637 25.5714 20.4547 25.5714V27.2693ZM7.60282 27.2693H20.4547V25.5714H7.60282V27.2693ZM5.34539 25.0118C5.34539 26.2586 6.35608 27.2693 7.60282 27.2693V25.5714C7.29378 25.5714 7.04325 25.3209 7.04325 25.0118H5.34539ZM5.34539 11.125V25.0118H7.04325V11.125H5.34539ZM5.6156 11.9739H6.19432V10.2761H5.6156V11.9739Z",
    fill: "url(#paint6_linear_5554_11741)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5554_11741",
    x1: 12.0879,
    y1: 21.6063,
    x2: 12.0879,
    y2: 23.7763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54AAE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5554_11741",
    x1: 12.0957,
    y1: 18.3055,
    x2: 12.0957,
    y2: 20.4755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54AAE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5554_11741",
    x1: 12.1054,
    y1: 15.0008,
    x2: 12.1054,
    y2: 17.1708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54AAE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5554_11741",
    x1: 15.9785,
    y1: 21.6063,
    x2: 15.9785,
    y2: 23.7763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54AAE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5554_11741",
    x1: 15.9863,
    y1: 18.3055,
    x2: 15.9863,
    y2: 20.4755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54AAE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5554_11741",
    x1: 15.9961,
    y1: 15.0008,
    x2: 15.9961,
    y2: 17.1708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EEDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54AAE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5554_11741",
    x1: 20.3131,
    y1: 8.81559,
    x2: 5.05813,
    y2: 23.0189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54AAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EEDD2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/Hotel.32431bebfcd70e11911b9a7938e29a64.svg";
export { ForwardRef as ReactComponent };